import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../_commons/integration.reducer";

export const initialStripePaymentsReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },

    workdayImportLoading: false,
    workdayRefundImportLoading: false,
    workdayDepositImportLoading: false,

    workdayImportErrorMessage: null,
};

const StripePaymentsSlice = createSlice({
    name: "StripePayments",
    initialState: { ...initialStripePaymentsReducer },
    reducers: {
        ...integrationReducerActions,

        startWorkdayImportRequest(state) {
            state.workdayImportLoading = true;
            state.workdayImportErrorMessage = undefined;
        },
        startWorkdayImportSuccess(state, action) {
            state.workdayImportLoading = false;
            state.configuration = action.payload;
            state.editConfiguration = action.payload;
        },
        startWorkdayImportFailure(state, action) {
            state.workdayImportLoading = false;
            state.workdayImportErrorMessage = action.payload;
        },
    },
});

export default StripePaymentsSlice;
